const AUTH_TOKEN_KEY = 'invi8_token'
const AUTH_SESSION_KEY = 'invi8_session'
const AUTH_USER_KEY = 'invi8_user'

const hasStorage = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'

const getAuthToken = () => {
  if (!hasStorage()) return null
  return localStorage.getItem(AUTH_TOKEN_KEY)
}

const parseJwt = (token) => {
  if (!token || typeof token !== 'string') return null
  const parts = token.split('.')
  if (parts.length < 2) return null
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, '=')
    const json = atob(padded)
    return JSON.parse(json)
  } catch {
    return null
  }
}

const setAuthToken = (token) => {
  if (!hasStorage()) return
  if (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token)
  }
}

const setAuthSession = (value = 'true') => {
  if (!hasStorage()) return
  if (value && typeof value === 'object') {
    const existing = getAuthSession() || {}
    localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify({ ...existing, ...value }))
    return
  }
  localStorage.setItem(AUTH_SESSION_KEY, String(value))
}

const getAuthSession = () => {
  if (!hasStorage()) return null
  const raw = localStorage.getItem(AUTH_SESSION_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return raw === 'true' ? { loggedIn: true } : null
  }
}

const getAuthUser = () => {
  if (!hasStorage()) return null
  const raw = localStorage.getItem(AUTH_USER_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

const setAuthUser = (user) => {
  if (!hasStorage()) return
  if (!user) return
  const existingUser = getAuthUser() || {}
  localStorage.setItem(
    AUTH_USER_KEY,
    JSON.stringify({
      ...existingUser,
      ...user,
      s_id:
        user.s_id ||
        user.id ||
        user.user_id ||
        user.vendor_id ||
        user.vendorId ||
        existingUser.s_id ||
        existingUser.id ||
        existingUser.user_id ||
        existingUser.vendor_id ||
        existingUser.vendorId ||
        ''
    })
  )
}

const clearAuth = () => {
  if (!hasStorage()) return
  localStorage.removeItem(AUTH_TOKEN_KEY)
  localStorage.removeItem(AUTH_SESSION_KEY)
  localStorage.removeItem(AUTH_USER_KEY)
}

const isAuthenticated = () => {
  if (!hasStorage()) return false
  return Boolean(getAuthToken() || localStorage.getItem(AUTH_SESSION_KEY))
}

const getAuthUserId = () => {
  const user = getAuthUser() || {}
  const fromUser =
    user.id ||
    user.user_id ||
    user.vendor_id ||
    user.vendorId ||
    user.s_id ||
    ''
  if (fromUser) return fromUser
  const token = getAuthToken()
  const payload = parseJwt(token) || {}
  return (
    payload.user_id ||
    payload.id ||
    payload.vendor_id ||
    payload.vendorId ||
    payload.sub ||
    ''
  )
}

const getAuthRole = () => {
  const session = getAuthSession() || {}
  if (session.type) return session.type
  if (session.role) return session.role
  const user = getAuthUser() || {}
  return user.type || user.role || user.user_role || user.account_type || ''
}

export {
  AUTH_TOKEN_KEY,
  AUTH_SESSION_KEY,
  AUTH_USER_KEY,
  getAuthSession,
  getAuthRole,
  getAuthToken,
  getAuthUser,
  getAuthUserId,
  setAuthToken,
  setAuthUser,
  setAuthSession,
  clearAuth,
  isAuthenticated
}
